<script type="text/javascript">

    import {http} from '../../../system/http.js';

    export default {

        data: function () {
            return {
                requiredLogin: false,
                permalink: permalink,
                user: null,
                settingsLogin: null,
                loading: false
            }
        },

        mounted: function () {
            this.$event_bus.$on('LoadUserData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;
            });

            this.$event_bus.$on('LoadData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;
            });

            this.$event_bus.$on('LoadEventData', (data) => {
                this.user = data.user;
                this.settingsLogin = data.settings_login;
            });

        },

        methods: {
            codeSent() {
                const dataFrm = new FormData($('#login-frm')[0]);
                this.loading = true;

                this.$event_bus.$emit('beforeCode', 'login');

                http.post('/book/' + this.permalink + '/submit-login', dataFrm)
                    .then(({data}) => {
                        this.$event_bus.$emit('codeSent', data);
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                        if (error.response && error.response.status === 429) {
                            swal({
                                title: trans('global.error_title'),
                                text: trans('online_booking.rate_limit_client_get_pin'),
                                showCancelButton: false,
                                showLoaderOnConfirm: true,
                                closeOnConfirm: true,
                            }, () => {});
                        }

                        this.$setErrorBag(errorBag);
                    });
            },

            signMeUp() {
                this.$event_bus.$emit('signMeUp', {user: this.user, settingsLogin: this.settingsLogin});
            },

            fbLogin() {
                var win = window.open('/book/' + this.permalink + '/submit-facebook', 'FacebookLoginWindow', 'height=500,width=600,scrollbars,status');
                var redirectUrl = [location.protocol, '//', location.host, location.pathname].join('');
                var timer = setInterval(function() {
                    // Check if the client reached the last page of the OAuth flow
                    var url;
                    try {
                        url = win.location.href + '';
                    } catch (e) {
                        return;
                    }

                    if (win.closed) {
                        clearInterval(timer);
                        window.location.href = redirectUrl
                    }

                    redirectUrl = [location.protocol, '//', location.host, location.pathname].join('');
                    // Determines if the client is on page after having unique account
                    var isBookingPage = url.indexOf('/book/') !== -1 && url.indexOf('/auth/') === -1 && url.indexOf('/login-facebook') === -1;
                    // Determines if the client is on page after choosing from 2 account
                    var isCenterPage = url.indexOf('/center') !== -1
                    // Check if there was an error when logging in
                    var $alerts = win.document.getElementsByClassName('alert-danger')
                    var $successes = win.document.getElementsByClassName('alert-success')
                    var hasSuccess = $successes.length > 0
                    var errors = []
                    for (var i = 0; i < $alerts.length; i++) {
                        errors.push($alerts[i].innerText.trim())
                    }

                    if (isBookingPage || isCenterPage) {
                        redirectUrl = redirectUrl + $.param({
                            //login_successful: hasSuccess,
                            errors: errors
                        });
                        win.postMessage({ fbLoggedIn: true }, '*')
                        win.close()
                        clearInterval(timer);
                        window.location.href = redirectUrl
                    }
                }, 500);
            },

            goBackToChoose() {
                this.$event_bus.$emit('goBackToChoose');
            }
        },
    };


</script>


<template id="login">

    <div class="row">

        <div class="col-sm-8 col-sm-offset-2">

            <div class="card-box login-box">
                <div class="text-center">
                    <h4 class="text-uppercase font-bold m-b-0">{{ trans('online_booking.login') }}</h4>
                </div>
                <div class="panel-body">
                    <form v-on:submit.prevent="codeSent" id="login-frm" class="form-horizontal m-t-20 no-overflow">

                        <div class="form-group">
                            <div class="col-xs-12">
                                {{ trans('online_booking.phone_email_description_1') }}
                                {{ trans('online_booking.phone_email_description_2') }}
                            </div>
                        </div>

                        <div class="form-group" :class="{ 'has-error' : errors.has('phone_email') }">
                            <div class="col-xs-12">
                                <input class="form-control input-login" type="text" name="phone_email"
                                       :placeholder="trans('online_booking.phone_email')">
                                <span v-if="errors.has('phone_email')" class="help-block m-b-0">{{ errors.first('phone_email') }}</span>
                            </div>
                        </div>


                        <div class="form-group text-center m-t-20">
                            <div class="col-xs-12">
                                <button type="button" class="btn btn-lg btn-custom btn-block"
                                        @click="codeSent()" v-if="!loading">
                                    {{ trans('online_booking.send_pin') }}
                                </button>
                                <div class="btn btn-lg btn-custom btn-block btn-login-loading" v-if="loading">
                                    <div class="preloader"></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="user && user.is_facebook_client_login_enabled">
                            <div class="form-group">
                                <div class="col-xs-12 span-fb-divider">
                                    <div>{{ trans('online_payment.or') }}</div>
                                </div>
                            </div>

                            <div class="form-group text-center m-t-20">
                                <div class="col-xs-12">
                                    <button type="button" @click="fbLogin"
                                            class="btn btn-lg btn-facebook btn-block">
                                        <i class="zmdi zmdi-facebook-box m-r-10"></i>
                                        <span>{{ trans('online_booking.login_with_facebook') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group m-b-0" v-if="settingsLogin && settingsLogin.allow_create == 1">
                            <div class="col-sm-12 m-t-20 choose-user-bottom">
                                <a class="btn btn-default" @click="goBackToChoose">
                                    <i class="zmdi zmdi-chevron-left m-r-10 alert-ico"></i>
                                    {{ trans('global.back') }}
                                </a>
                            </div>
                        </div>

                    </form>

                </div>

            </div>


        </div>


    </div>

</template>
